/** Card actions only: never changes product purchase eligibility or checkout. */
export function isProtectedCardProduct(product: any, ...paths: string[]): boolean {
  if (product?.isInquiryOnly === true || (Array.isArray(product?.tags) && product.tags.some(tag => String(tag).toLowerCase() === 'inquiry-only'))) return true;
  const values = [product?.brand, product?.vendor, product?.named_tags?.brand, product?.handle, ...paths];
  return values.some(value => {
    let text = String(value || '');
    try { text = decodeURIComponent(text); } catch (_) { /* Keep original malformed path. */ }
    return /rolex|tag[\s_-]*heuer/i.test(text);
  });
}

function inventoryQuantity(value: unknown): number | undefined {
  if (typeof value !== 'number' && (typeof value !== 'string' || !value.trim())) return undefined;
  const number = Number(value);
  return Number.isFinite(number) ? number : undefined;
}

/** Only variant-level stock is relevant. Product aggregate stock and commercial tags are not stock evidence. */
export function productCardCTA(product: any, productUrl: string, pagePath = ''): { inquiry: boolean; href: string } {
  const unchanged = { inquiry: false, href: productUrl };
  if (!product || isProtectedCardProduct(product, productUrl, pagePath)) return unchanged;
  try {
    const url = new URL(productUrl, 'https://native.invalid');
    if (!/^https?:$/.test(url.protocol) || !/^\/(?:fr\/)?products\/[a-z0-9-]+\/?$/i.test(url.pathname)
      || url.searchParams.has('key') || url.searchParams.has('inquiry')) return unchanged;
  } catch (_) { return unchanged; }
  const variant = product.selectedVariant;
  const available = variant ? variant.availableForSale : product.inventory_available;
  const quantity = inventoryQuantity(variant ? variant.totalInventory : product.inventory_quantity);
  // Zero physical stock still requires an inquiry when Shopify allows backorders.
  if (available !== false && !(quantity !== undefined && quantity <= 0)) return unchanged;
  return { inquiry: true, href: productUrl.split('#')[0] + '#modal-contact' };
}
